import { buildSorter } from '../highlighter/highlighter-utils';

const mergeSpans = (
  map1: CMxCommonApp.SpanActivations,
  map2: CMxCommonApp.SpanActivations
): CMxCommonApp.SpanActivations => {
  const keys2 = Object.keys(map2);
  const targetMap = clone<CMxCommonApp.SpanActivations>(map1);

  keys2.forEach(key => {
    if (!Array.isArray(targetMap[key])) {
      targetMap[key] = map2[key];
    } else {
      const incoming = new Set(map2[key].map(item => item.span.hash));
      const filtered: CMxArtifacts.UnstructuredSpan[] = targetMap[key].filter(
        item => !incoming.has(item.span.hash)
      );
      const combined: CMxArtifacts.UnstructuredSpan[] = [
        ...filtered,
        ...map2[key]
      ];
      targetMap[key] = combined.sort(buildSorter());
    }
  });
  return targetMap;
};

const pruneSpans = (
  map1: CMxCommonApp.SpanActivations,
  map2: CMxCommonApp.SpanActivations
) => {
  const keys2 = Object.keys(map2);
  const targetMap = clone<CMxCommonApp.SpanActivations>(map1);

  keys2.forEach(key => {
    const removalArray = map2[key];
    if (targetMap[key]) {
      removalArray.forEach((itemToRemove: CMxArtifacts.UnstructuredSpan) => {
        targetMap[key] = targetMap[key].filter(
          item => item.span.hash !== itemToRemove.span.hash
        );
      });
    }
  });

  const targetKeys = Object.keys(targetMap);
  targetKeys.forEach(key => {
    if (targetMap[key].length === 0) {
      delete targetMap[key];
    }
  });
  return targetMap;
};

const clone = <T>(obj: any): T => {
  return JSON.parse(JSON.stringify(obj));
};

export { mergeSpans, pruneSpans, clone };
